import { CoreModel } from '../core/core.model';
export class RatingModel extends CoreModel {
/**
 * Label for component
 */
label?: string;
/**
 * Name of icon
 */
icon?: string;
/**
 * Value of rating and means number of filled/selected icons
 */
value?: number;
/**
 * Number of rating icons
 */
max?: number;
/**
 * Means to start icons counting order
 */
countFromEnd?: boolean;
/**
 * Means to show icons vertically
 */
iconsVertical?: boolean;
/**
 * It is constructor, which take values from Rating Component and create Rating Model object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function RatingModel_tsickle_Closure_declarations() {
/**
 * Label for component
 * @type {?}
 */
RatingModel.prototype.label;
/**
 * Name of icon
 * @type {?}
 */
RatingModel.prototype.icon;
/**
 * Value of rating and means number of filled/selected icons
 * @type {?}
 */
RatingModel.prototype.value;
/**
 * Number of rating icons
 * @type {?}
 */
RatingModel.prototype.max;
/**
 * Means to start icons counting order
 * @type {?}
 */
RatingModel.prototype.countFromEnd;
/**
 * Means to show icons vertically
 * @type {?}
 */
RatingModel.prototype.iconsVertical;
}

